import {
 Alert,
 Button,
 Checkbox,
 Col,
 DatePicker,
 Form,
 Input,
 InputNumber,
 Popover,
 Radio,
 Row,
 Select,
} from 'antd'
import { FormInstance } from 'antd/es/form/Form'
import BaseTDPicker from 'components/elements/BaseComponents/BaseTDPicker'
import InputWithBaseSelector from 'components/elements/InputWithBaseSelector'
import { TAddLeadEventBody, TLeadsNames } from 'features/leads'
import { watch } from 'fs'
import useFetchPage from 'hooks/useFetchPage'
import { baseTime } from 'lib'
import {
 getWeekDayFromDate,
 getWeekdayPositionFromDate,
 getWeekdayOfCurrentMonth,
} from 'lib/date-utils'
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { taskTypes } from 'static-data'
import { TMode } from 'types'
import { TAddTask } from 'features/calendar'
import { eventReminder } from 'utils/functions'
import { BaseButton } from 'components/elements/BaseButton'

const optionsWeeklyDays = [
 { label: 'Sun', value: 'Sunday' },
 { label: 'Mon', value: 'Monday' },
 { label: 'Tue', value: 'Tuesday' },
 { label: 'Wed', value: 'Wednesday' },
 { label: 'Thu', value: 'Thursday' },
 { label: 'Fri', value: 'Friday' },
 { label: 'Sat', value: 'Saturday' },
]

const optionsSelectedType = [
 { label: 'Daily', value: 'daily' },
 { label: 'Weekly', value: 'weekly' },
 { label: 'Monthly', value: 'monthly' },
 { label: 'Yearly', value: 'yearly' },
]

const optionsWeek = [
 { label: 'First', value: '1' },
 { label: 'Second', value: '2' },
 { label: 'Third', value: '3' },
 { label: 'Fourth', value: '4' },
 { label: 'Last', value: '5' },
]

const optionsDays = [
 { label: 'Monday', value: 'Monday' },
 { label: 'Tuesday', value: 'Tuesday' },
 { label: 'Wednesday', value: 'Wednesday' },
 { label: 'Thursday', value: 'Thursday' },
 { label: 'Friday', value: 'Friday' },
 { label: 'Saturday', value: 'Saturday' },
 { label: 'Sunday', value: 'Sunday' },
]

const TaskFormBlock: FC<{
 isRecurringTask?: boolean
 editableType?: 'single' | 'multiple'
 autoFocusTitle?: boolean
 leadId?: any
 form: FormInstance
 mode?: TMode
 initialValues?: any
}> = ({
 form,
 initialValues,
 mode,
 leadId,
 autoFocusTitle,
 editableType,
 isRecurringTask,
}) => {
 const [searchKey, setSearchKey] = useState('')
 const { flatData, isLoading, hasMore, fetchMore } = useFetchPage<TLeadsNames>(
  'get-leads-name',
  {
   method: 'post',
   body: useMemo(
    () => ({
     search: searchKey,
    }),
    [searchKey],
   ),
  },
 )

 const watch = Form.useWatch([], form)
 const dateValue = Form.useWatch('scheduled_at', form) as baseTime.Moment

 const eventRemiderList = useMemo(() => eventReminder(dateValue), [dateValue])

 const handleUpdateTimeField = useCallback(
  (e: baseTime.Moment | string, type?: keyof TAddTask) => {
   const timeDate = baseTime(e)
   const dd = baseTime(watch?.end_value_specific ?? '')
   const enncodeDate = getWeekdayPositionFromDate(timeDate)
   if (enncodeDate) {
    form.setFieldsValue({
     ...(type !== 'scheduled_at' ? { scheduled_at: timeDate } : {}),
     ...(type !== 'monthly_date'
      ? { monthly_date: timeDate.get('D') ?? baseTime().get('D') }
      : {}),
     ...(type !== 'selected_week'
      ? { selected_week: `${enncodeDate.weekNumber}` as any }
      : {}),
     ...(type !== 'monthly_day' ? { monthly_day: enncodeDate.weekday } : {}),
     weekly_days: [enncodeDate.weekday],
    })
   }

   if (dd.isBefore(timeDate)) {
    form.resetFields(['end_value_specific'])
   }
  },
  [form, watch?.end_value_specific],
 )

 //  useEffect(() => {
 //   if (mode === 'EDIT' && editData) {
 //    const { recurring } = editData
 //    form.setFieldsValue({
 //     title: editData.title,
 //     type: editData.type,
 //     reminder: editData.reminder,
 //     scheduled_at: baseTime(`${editData.date} ${editData.time}`),
 //     lead_id: [{ title: editData?.lead?.name, id: editData?.lead?.id }] as any,
 //     // lead_id: editData.lead_id,
 //     ...(editData?.is_recurring
 //      ? {
 //         repeat_event: editData?.is_recurring === 1,
 //         difference_month: recurring?.difference_month,
 //         selected_type: recurring?.selected_type,
 //         end_type: recurring?.end_type,
 //         monthly_selected_type: recurring?.monthly_selected_type ?? 'date',
 //         ...(recurring?.end_date && recurring?.end_type
 //          ? {
 //             end_value_after:
 //              recurring?.end_type === 'after' ? Number(recurring?.end_date) : 1,
 //             end_value_specific:
 //              recurring?.end_type === 'specific_date'
 //               ? (baseTime(recurring?.end_date) as any)
 //               : undefined,
 //            }
 //          : {}),
 //         ...(recurring?.selected_type === 'weekly' &&
 //          recurring?.weekly_days && {
 //           weekly_days: JSON.parse(recurring?.weekly_days ?? ''),
 //          }),
 //         ...(recurring?.selected_type === 'monthly' && {
 //          selected_week: recurring?.selected_week,
 //          monthly_day:
 //           recurring?.monthly_selected_type === 'day'
 //            ? recurring?.monthly_day
 //            : baseTime().format('dddd'),
 //          monthly_date:
 //           recurring?.monthly_selected_type === 'date'
 //            ? Number(recurring?.monthly_date ?? 0)
 //            : Number(baseTime().format('DD') ?? 1),
 //         }),
 //        }
 //      : {}),
 //    })
 //   } else {
 //    form.resetFields()
 //   }
 //   return () => {
 //    form.resetFields()
 //   }
 //  }, [editData, form, mode])

 return (
  <div>
   <Form
    className="add-task-form"
    form={form}
    layout="vertical"
    initialValues={initialValues}
   >
    {!leadId && (
     <Form.Item
      name="lead_id"
      rules={[{ required: true, message: 'Lead name is required' }]}
      label="Lead name"
     >
      {/* <SelectLeadBlock formMode={mode} /> */}
      <InputWithBaseSelector
       disabled={mode === 'EDIT'}
       flatData={flatData?.map((i) => ({ id: i?.id, name: i?.name })) ?? []}
       isLoading={isLoading}
       hasMore={hasMore}
       fetchMore={fetchMore}
       setSearchKey={setSearchKey}
       type="single"
       placeholder={{ folder: 'Select Lead', input: 'Select Lead' }}
      />
     </Form.Item>
    )}
    <Form.Item
     name="title"
     rules={[{ required: true, message: 'Title is required' }]}
     label="Title"
    >
     <Input placeholder="Enter Title" autoFocus={autoFocusTitle} />
    </Form.Item>
    <Form.Item
     name="type"
     label="Type"
     rules={[{ required: true, message: 'Type is required' }]}
    >
     <Select placeholder="Select Type" options={taskTypes} />
    </Form.Item>
    <Form.Item
     name="scheduled_at"
     label="Date & Time"
     getValueFromEvent={(e) => {
      if (e) {
       handleUpdateTimeField(e, 'scheduled_at')
      } else {
       form.setFieldsValue({
        monthly_date: baseTime().get('D'),
       })
      }

      return e
     }}
     rules={[{ required: true, message: 'Date & Time is required' }]}
    >
     <BaseTDPicker
      disableExtraMinute={20}
      inputReadOnly
      showNow={false}
      disablePastTime
     />
    </Form.Item>
    {eventRemiderList && eventRemiderList.length > 0 && (
     <Form.Item name="reminder" label="Set Reminder">
      <Select placeholder="Set Reminder" options={eventRemiderList} />
     </Form.Item>
    )}
    {(mode === 'ADD' || (mode === 'EDIT' && editableType === 'multiple')) && (
     <>
      {(mode === 'ADD' || (mode === 'EDIT' && isRecurringTask)) && (
       <Form.Item
        name="repeat_event"
        getValueFromEvent={({ target }) => target?.checked ?? false}
       >
        <Checkbox disabled={!watch?.scheduled_at} checked={watch?.repeat_event}>
         Repeat event
        </Checkbox>
       </Form.Item>
      )}
      {watch?.repeat_event &&
       watch?.scheduled_at &&
       (mode === 'ADD' || (mode === 'EDIT' && isRecurringTask)) && (
        <>
         <Form.Item name="selected_type">
          <Select defaultValue="daily" options={optionsSelectedType} />
         </Form.Item>
         {watch.selected_type === 'weekly' && (
          <Form.Item
           name="weekly_days"
           rules={[{ required: true, message: 'Please choose any day' }]}
          >
           <CustomCheckBoxButtonGroup
            selectedWeekDay={getWeekDayFromDate(watch.scheduled_at)}
            items={optionsWeeklyDays}
            className={`add-task__select-days ${false ? 'is-error' : ''}`}
           />
          </Form.Item>
         )}

         {watch.selected_type === 'monthly' && (
          <Row gutter={[10, 0]}>
           {watch.scheduled_at &&
            [29, 30, 31].includes(watch.scheduled_at?.get('D') ?? 0) && (
             <Col span={24}>
              <Alert
               className="mb-2"
               description="If any of the selected month has no such date, the event will not be scheduled for those particular months."
               type="info"
              />
             </Col>
            )}
           <Col span={16}>
            <Form.Item name="monthly_selected_type" className="m-2">
             <Radio.Group className="w-100">
              <Row gutter={[10, 10]}>
               <Col span={24}>
                <Row gutter={[10, 0]}>
                 <Col span={6}>
                  <Radio value="date" className="w-100 day-select-radio-group">
                   <div className="pe-2"> Date</div>
                  </Radio>
                 </Col>
                 <Col span={18}>
                  <Form.Item
                   getValueFromEvent={(e) => {
                    const ddd = baseTime()
                    const elm = ddd.set('D', e)
                    if (watch.scheduled_at) {
                     if (elm.isBefore(baseTime())) {
                      const scheduledAt = elm.add(1, 'M')
                      handleUpdateTimeField(scheduledAt, 'monthly_date')
                     } else {
                      handleUpdateTimeField(elm, 'monthly_date')
                     }
                    } else {
                     const scheduledAt = baseTime().set('D', e)
                     const enncodeDate = getWeekdayPositionFromDate(scheduledAt)
                     form.setFieldsValue({
                      scheduled_at: scheduledAt,
                      monthly_day: enncodeDate.weekday,
                      weekly_days: [enncodeDate.weekday],
                     })
                    }

                    return e
                   }}
                   className="picker-form-item mb-0"
                   name="monthly_date"
                  >
                   <MonthlyDayPicker
                    disabled={watch.monthly_selected_type !== 'date'}
                   />
                  </Form.Item>
                 </Col>
                </Row>
               </Col>
               <Col span={24}>
                <Row gutter={[10, 0]}>
                 <Col span={6}>
                  <Radio value="day" className="w-100 day-select-radio-group">
                   <div className="d-flex w-100" style={{ columnGap: '10px' }}>
                    Day
                   </div>
                  </Radio>
                 </Col>
                 <Col span={9}>
                  <Form.Item
                   className="mb-0"
                   getValueFromEvent={(e: any) => {
                    const monthlyDay = watch?.monthly_day as any
                    const value = getWeekdayOfCurrentMonth(
                     Number(e),
                     monthlyDay,
                    )
                    if (value) {
                     handleUpdateTimeField(value, 'selected_week')
                     // form.setFieldsValue({ scheduled_at: value })
                    }

                    return e
                   }}
                   name="selected_week"
                  >
                   <Select
                    disabled={watch.monthly_selected_type !== 'day'}
                    defaultValue={watch?.selected_week ?? '1'}
                    options={optionsWeek}
                   />
                  </Form.Item>
                 </Col>
                 <Col span={9}>
                  <Form.Item
                   className="mb-0"
                   name="monthly_day"
                   getValueFromEvent={(e: any) => {
                    const days = watch?.selected_week as any
                    const value = getWeekdayOfCurrentMonth(Number(days), e)
                    if (value) {
                     handleUpdateTimeField(value, 'monthly_day')
                     // form.setFieldsValue({ scheduled_at: value })
                    }

                    return e
                   }}
                  >
                   <Select
                    disabled={watch.monthly_selected_type !== 'day'}
                    defaultValue={
                     watch?.monthly_day ?? baseTime().format('dddd')
                    }
                    options={optionsDays}
                   />
                  </Form.Item>
                 </Col>
                </Row>
               </Col>
              </Row>
             </Radio.Group>
            </Form.Item>
           </Col>
           <Col span={8} className="my-auto">
            <Row>
             <Col span={14} className="my-auto">
              <Form.Item name="difference_month">
               <InputNumber min={1} max={12} />
              </Form.Item>
             </Col>
             <Col span={10}>
              <span className="ps-1"> of every month(s) </span>
             </Col>
            </Row>
           </Col>
          </Row>
         )}

         <div>End:</div>
         <div className="ps-2">
          <Form.Item
           name="end_type"
           getValueFromEvent={({ target }) => {
            if (target?.value === 'specific_date') {
             form.resetFields(['end_value_after'])
            } else if (target?.value === 'after') {
             form.resetFields(['end_value_specific'])
            }
            return target?.value
           }}
          >
           <Radio.Group className="w-100">
            <Row className="w-100">
             <Col span={12}>
              <Radio value="after">
               <Row>
                <span className="pe-2 pt-1"> After</span>
                <Form.Item name="end_value_after">
                 <InputNumber
                  max={99}
                  min={1}
                  onFocus={() => {
                   form.setFieldValue('end_type', 'after')
                   //  form.resetFields(['end_value_specific'])
                  }}
                 />
                </Form.Item>
                <span className="ps-2 pt-1"> event(s)</span>
               </Row>
              </Radio>
             </Col>

             <Col span={12}>
              {watch.end_type === 'after' && (
               <Radio value="specific_date">
                <p>
                 {watch?.end_value_specific
                  ? `Till ${baseTime(watch.end_value_specific)?.format(
                     'MMM.DD, YYYY',
                    )}`
                  : 'Specific date'}
                </p>
               </Radio>
              )}
              {watch.end_type === 'specific_date' && (
               <Form.Item name="end_value_specific">
                <DatePicker
                 className="w-100 fix-date-trigger-issue"
                 disabledDate={(current) => {
                  return current.isSameOrBefore(
                   watch.scheduled_at ? watch.scheduled_at : baseTime(),
                   'day',
                  )
                 }}
                 format="YYYY-MM-DD"
                 onFocus={() => {
                  form.setFieldValue('end_type', 'specific_date')
                  //  form.resetFields(['end_value_after'])
                 }}
                />
               </Form.Item>
              )}
             </Col>
            </Row>
           </Radio.Group>
          </Form.Item>
         </div>
        </>
       )}
     </>
    )}
   </Form>
  </div>
 )
}

export default TaskFormBlock

export const CustomCheckBoxButtonGroup: FC<{
 selectedWeekDay?: string
 value?: any[]
 onChange?: (val: any[]) => void
 items: { label: string; value: string }[]
 className?: string
}> = ({ onChange, value = [], items, className, selectedWeekDay }) => {
 return (
  <Row className={className ?? ''}>
   {items?.map((item) => (
    <Button
     key={item?.value}
     onClick={() => {
      if (value?.includes(item?.value)) {
       if (selectedWeekDay !== item?.value) {
        onChange?.(value?.filter?.((n) => n !== item?.value))
       }
      } else {
       onChange?.([...value, item?.value])
      }
     }}
     type={value?.includes(item?.value) ? 'primary' : 'text'}
     className="mx-1 my-1"
    >
     {item?.label}
    </Button>
   ))}
  </Row>
 )
}

export const MonthlyDayPicker: FC<{
 disabled?: boolean
 value?: number
 onChange?: (v?: number) => void
}> = ({ onChange, value, disabled }) => {
 const [selectedKey, setSelectedKey] = useState(value ?? 1)
 const [show, setShow] = useState(false)

 useEffect(() => {
  setSelectedKey(value ?? 1)
 }, [value])

 return (
  <div className="monthly-day-picker">
   <Popover
    visible={show}
    overlayClassName="monthly-day-picker-popup"
    onVisibleChange={(v) => {
     setShow(v)
    }}
    trigger="click"
    content={
     <div className="picker__popup">
      <div className="picker__popup-wrapper">
       {Array.from(Array(31).keys()).map((i, n) => (
        <span
         key={n}
         className={`popup__items ${
          i + 1 === selectedKey ? 'item-active' : ''
         }`}
         onClick={() => setSelectedKey(i + 1)}
        >
         {i + 1}
        </span>
       ))}
      </div>
      {[29, 30, 31].includes(selectedKey) && (
       <div className="extra-footer">
        If any of the selected month has no such date, the event will not be
        scheduled for those particular months.
       </div>
      )}
      <div className="footer-btns">
       <BaseButton
        onClick={() => setShow(false)}
        size="middle"
        className="me-2"
       >
        Cancel
       </BaseButton>

       <BaseButton
        onClick={() => {
         onChange?.(selectedKey)
         setShow(false)
        }}
        size="middle"
        type="primary"
       >
        Submit
       </BaseButton>
      </div>
     </div>
    }
   >
    <Input
     disabled={disabled}
     className="picker__input"
     suffix={
      <Button
       disabled={disabled}
       style={{ height: 'auto', width: 'auto', lineHeight: 1 }}
       className="p-0"
       type="link"
       onClick={(e) => {
        if (!disabled) {
         e.preventDefault()
         setShow(true)
        }
       }}
       icon={<i className="far fa-calendar" />}
      />
     }
     placeholder="Select Day"
     value={selectedKey ?? 1}
    />
   </Popover>
  </div>
 )
}
